import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useHistoryList } from './HistoryProvider';
import { screenName } from '../../Const/constant';
import { Home, Package, Truck, User2, Bell } from 'lucide-react';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import LocateIcon from '@mui/icons-material/LocationOn';

// Icon mapping for navigation items
const iconMap = {
  '/dashboard': Home,
  '/doc-master-list': Package,
  '/report': Truck,
  '/print': LocalPrintshopIcon,
  '/user_management': User2,
  '/location': LocateIcon,
  '/alerts': Bell
};

function Breadcrumbs({ backNav, backDash }) {
  const { breadcrumbList, removeCustomPath, customPath } = useHistoryList();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (item, index) => {

    const isLast = index === breadcrumbList.length - 1;

    if (customPath && customPath.path != null && customPath.isCustom === true && isLast === false) {
      backNav(item);
    }

    if (item === '/dashboard' && location.pathname === '/user_management') {
      backDash(item);
      return
    }

    // If clicking the current page, do nothing
    if (isLast) {
      return;
    }

    // If it's a custom path (display-only), do nothing
    if (item.isCustom) {
      return;
    }

    // Remove custom path if navigating away
    removeCustomPath();

    // Navigate to the path
    navigate(item.path || item);
  };

  // Don't show breadcrumbs if only dashboard is present
  if (breadcrumbList.length <= 1 && location.pathname === '/dashboard') {
    return null;
  }

  const getIcon = (item) => {
    const path = item.path || item;
    const IconComponent = iconMap[path];
    return IconComponent;
  };

  const getDisplayName = (item) => {
    if (item.isCustom) {
      return item.path; // Custom name as-is
    }
    const path = item.path || item;
    return screenName[path.replace(/^\//, '')] || path;
  };

  return (
    <div
      className="location-breadcrumb"
      style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '12px 16px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0'
      }}
    >
      {breadcrumbList.map((item, index) => {
        const Icon = getIcon(item);
        const isLast = index === breadcrumbList.length - 1;
        const isCustom = item.isCustom;

        return (
          <React.Fragment key={index}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {Icon && (
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: isLast ? '#1976d2' : '#757575'
                }}>
                  <Icon size={18} />
                </span>
              )}
              <span
                onClick={() => handleClick(item, index)}
                key={item}
                style={{
                  textDecoration: 'none',
                  color: isLast ? '#1976d2' : isCustom ? '#9e9e9e' : '#757575',
                  cursor: (isLast || isCustom) ? 'default' : 'pointer',
                  fontWeight: isLast ? '600' : '400',
                  fontSize: '14px',
                  transition: 'color 0.2s',
                  fontStyle: isCustom ? 'italic' : 'normal'
                }}
                onMouseEnter={(e) => {
                  if (!isLast && !isCustom) e.target.style.color = '#1976d2';
                }}
                onMouseLeave={(e) => {
                  if (!isLast && !isCustom) e.target.style.color = '#757575';
                }}
              >
                {getDisplayName(item)}
              </span>
            </span>
            {!isLast && (
              <span style={{
                margin: '0 2px',
                color: '#bdbdbd',
                fontSize: '16px'
              }}>
                ❯
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default Breadcrumbs;